export enum StaffTypeToPrint {
    CIVILSERVANT = "lang.shared.official", 
    CONTRACT = "lang.shared.labor",
    CIVIL_LABOR = "lang.shared.civilLabor"
}
